<div style="width: 100%; text-align: center;">
  <h1>You do not have the appropriate permissions to view this page. Please contact your
    account management team.</h1>
</div>
